import React from "react";
import { useAdminAuth } from "./AdminAuthContext";
import AccessDenied from "./AdminAccessDenied";

function AdminRoleGuard({ allowedRoles = [], children }) {
    const { isAuthenticated, hasAnyRole } = useAdminAuth();

    if (!isAuthenticated) {
        return null; // Auth already handled by AdminAuth
    }

    if (allowedRoles?.length > 0 && !hasAnyRole(allowedRoles)) {
        return (
            <AccessDenied />
        );
    }

    return children;
}
export default AdminRoleGuard